<body class="ltr leftmenu">
    <form class="main-content side-content" [formGroup]="CourseLevelQualificationForm">
        <div class="main-container container-fluid">
            <div class="inner-body">
                <div class="row row-sm add-form">
                    <div class="col-lg-12 col-md-12">
                        <div class="card custom-card">
                            <div class="card-body">
                                <div class=" d-flex align-items-center pl-3">
                                    <img alt="Logo" src="../../assets/img/CollegeMaster.png" class="mh-45px pb-2">
                                    <div class="ml-2">
                                        <h3 class="main-content-label mb-1"><b>
                                                Course Level Qualification
                                            </b></h3>
                                        <p class="text-muted card-sub-title mb-0">
                                            Course Level Qualification
                                        </p>
                                    </div>
                                </div>
                                <hr class="mt-1 mb-2">
                                    <div class="row clearfix mt-3">
                                    <!-- Course -->
                                    <div class="col-sm-3">
                                    <div class="form-group">
                                        <mat-form-field appearance="outline" class="example-full-width">
                                        <mat-label>Course</mat-label>
                                        <mat-select #select22 placeholder="Course" class="colorblack"
                                            formControlName="CoCode" (selectionChange)="onCourseChange()">
                                        <mat-select-filter *ngIf="select22.focused" [placeholder]="'Programme'"
                                            [displayMember]="'CoName'" [array]="courseList"
                                            (filteredReturn)="filteredCourseList = $event">
                                        </mat-select-filter>
                                        <mat-option *ngFor="let item of filteredCourseList" [value]="item.CoCode">
                                            {{ item | displayValue:'CoCode':'CoName' }}
                                        </mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="CourseLevelQualificationForm.get('CoCode')?.hasError('required') &&
                                            CourseLevelQualificationForm.get('CoCode')?.touched">
                                            Course is required
                                        </mat-error>
                                        </mat-form-field>
                                    </div>
                                    </div>

                                    <!-- Course Level -->
                                    <div class="col-sm-3">
                                    <div class="form-group">
                                        <mat-form-field appearance="outline" class="example-full-width">
                                        <mat-label>Course Level</mat-label>
                                        <mat-select #select23 placeholder="Course Level" class="colorblack"
                                            formControlName="CdDesc">
                                        <mat-select-filter *ngIf="select23.focused" [placeholder]="'Programme Level'"
                                            [displayMember]="'CdDesc'" [array]="courseLevelList"
                                            (filteredReturn)="filteredCourseLevelList = $event">
                                        </mat-select-filter>
                                        <mat-option *ngFor="let item of filteredCourseLevelList" [value]="item.CdCode">
                                            {{ item | displayValue:'CdCode':'CdDesc' }}
                                        </mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="CourseLevelQualificationForm.get('CdDesc')?.hasError('required') &&
                                            CourseLevelQualificationForm.get('CdDesc')?.touched">
                                            Course Level is required
                                        </mat-error>
                                        </mat-form-field>
                                    </div>
                                    </div>
                                </div>
                                <hr>


                                <!-- Table -->
                                <div *ngIf="Table" class="row clearfix">
                                   <div class="col-sm-12">
                                    <div class="table-scroll">
                                        <table id="datatable" class="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th class="f600">
                                                        Sr No
                                                    </th>
                                                    <th class="f600">
                                                        Field Name
                                                    </th>
                                                    <th class="f600">
                                                        Field Visible
                                                    </th>
                                                    <th class="f600">
                                                        Validation
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let course of courseRecords; let i = index">
                                                    <td>
                                                        {{ i + 1 }}
                                                    </td>
                                                    <td>
                                                        {{ course.FormDisplayName }}
                                                    </td>
                                                    <td>
                                                        <mat-checkbox [checked]="course.FormVisible"
                                                            (change)="course.FormVisible = $event.checked">
                                                        </mat-checkbox>
                                                    </td>
                                                    <td>
                                                        <mat-checkbox [checked]="course.FormRequired"
                                                            (change)="course.FormRequired = $event.checked">
                                                        </mat-checkbox>
                                                        <mat-lable class="m-2">Required</mat-lable>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <!-- Save Button -->
                                    <div class="text-right mt-3">
                                        <button type="button" class="btn btn-primary floatright" (click)="saveFields()">
                                            Save
                                        </button>
                                    </div>
                                </div>
                            </div>     
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>
